import { axiosProxy } from '../../utils/axiosProxy';
import { actionType } from '../../constants/Vendors';

const url = '/vendors';

export const fetchVendorsList = () => async dispatch => {
  try {
    dispatch({
      type: actionType.FETCH_VENDORS_LIST_START,
    });

    const res = await axiosProxy({
      method: 'GET',
      url: `${url}`,
      params: {
        unpaged: true,
      },
    });

    dispatch({
      type: actionType.FETCH_VENDORS_LIST,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: actionType.FETCH_VENDORS_LIST_FAIL,
      payload: error,
    });
  }
};

export const fetchVendors = ({ page, size, search, sort, unpaged = false }) => async dispatch => {
  try {
    dispatch({
      type: actionType.FETCH_VENDORS_START,
    });

    const params = new URLSearchParams();
    if (unpaged) {
      params.append('unpaged', true);
    } else {
      params.append('page', page);
      params.append('size', size);
    }

    if (search) {
      params.append('search', search);
    }

    (sort || ['id,asc']).forEach(field => {
      params.append('sort', field);
    });

    const res = await axiosProxy({
      method: 'GET',
      params,
      url,
    });

    await dispatch({
      type: actionType.FETCH_VENDORS,
      payload: res.data,
    });
    return res.data;
  } catch (error) {
    dispatch({
      type: actionType.FETCH_VENDORS_FAIL,
      payload: error,
    });
  }
};

export const getVendorById = id => async dispatch => {
  try {
    dispatch({
      type: actionType.GET_VENDORS_BY_ID_START,
    });
    const res = await axiosProxy({
      method: 'GET',
      url: `${url}/${id}`,
    });

    dispatch({
      type: actionType.GET_VENDORS_BY_ID,
      payload: res.data,
    });
    return res.data;
  } catch (error) {
    dispatch({
      type: actionType.GET_VENDORS_BY_ID_FAIL,
      payload: error,
    });
    return Promise.reject(error);
  }
};

export const addVendor = data => async dispatch => {
  try {
    dispatch({
      type: actionType.ADD_VENDORS_START,
    });
    const res = await axiosProxy({
      method: 'POST',
      url,
      data,
    });

    await dispatch({
      type: actionType.ADD_VENDORS,
      payload: res.data,
    });

    return res.data;
  } catch (error) {
    dispatch({
      type: actionType.ADD_VENDORS_FAIL,
      payload: error,
    });
    return { error };
  }
};

export const updateVendor = (id, data) => async dispatch => {
  try {
    dispatch({
      type: actionType.UPDATE_VENDORS_START,
    });
    const res = await axiosProxy({
      method: 'PUT',
      data,
      url: `${url}/${id}`,
    });

    await dispatch({
      type: actionType.UPDATE_VENDORS,
      payload: res.data,
    });
    return res.data;
  } catch (error) {
    dispatch({
      type: actionType.UPDATE_VENDORS_FAIL,
      payload: error,
    });
    return { error };
  }
};

export const deleteVendor = id => async dispatch => {
  try {
    dispatch({
      type: actionType.DELETE_VENDORS_START,
    });
    await axiosProxy({
      method: 'DELETE',
      url: `${url}/${id}`,
    });

    await dispatch({
      type: actionType.DELETE_VENDORS,
      payload: id,
    });
  } catch (error) {
    dispatch({
      type: actionType.DELETE_VENDORS_FAIL,
      payload: error,
    });
  }
};

export const clearError = () => dispatch => {
  dispatch({
    type: actionType.CLEAR_VENDORS_ERROR,
  });
};
